import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from "@iscr/lib/utils";
import { Fragment } from "react";
import { Avatar } from "xAppLib/Avatar/Avatar";
const TYPE_STYLES = {
    GP: "bg-is-blue-20 text-is-blue",
    Cosmetic: "bg-is-green-20 text-is-green",
};
// An inactive doctor drops the type colour entirely rather than shading it - the list no longer
// carries an Active column, so the greyed-out avatar and the "Inactive" note beside the type are
// the only things saying so, and they have to read as different at a glance rather than on close
// comparison of two blues.
const INACTIVE_STYLES = "bg-is-gray-10 text-is-gray-90";
const AVATAR_SIZE_PX = {
    sm: 40,
    lg: 56,
};
const AVATAR_FONT_SIZE = {
    sm: "0.875rem",
    lg: "1.125rem",
};
export const DoctorAvatar = ({ name, nameAs: NameAs = "div", type, active = true, size = "sm", extra, }) => (_jsxs("div", { className: "flex items-center gap-4", children: [_jsx(Avatar, { name: name, size: AVATAR_SIZE_PX[size], autoColor: false, className: cn("shrink-0 font-semibold", active ? TYPE_STYLES[type] : INACTIVE_STYLES), style: { border: "none", fontFamily: "inherit", fontSize: AVATAR_FONT_SIZE[size] } }), _jsxs("div", { children: [_jsx(NameAs, { className: cn("mb-0", { "font-medium": NameAs === "div" }, !active && "text-is-gray-90"), children: name }), _jsx("div", { className: "flex items-center gap-1 text-sm text-is-gray-90", children: [type, ...(active ? [] : ["Inactive"]), ...(extra !== null && extra !== void 0 ? extra : [])].map((item, index) => (_jsxs(Fragment, { children: [index > 0 && _jsx("span", { children: "\u00B7" }), item] }, index))) })] })] }));
